<!-- components/HighRiskCorpratePopup.vue BR#188 pop-up notification in MU regarding high risk countries - mbeng-->
<template>
   <div
      v-if="visible && shouldShow"
      class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-30"
    >
    <div class="relative bg-white p-6 rounded-lg shadow-md max-w-sm w-full text-center">
        <button
            @click="$emit('close')"
            class="absolute top-3 right-3 text-gray-400 hover:text-black"
            >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
            </button>
                
          <div class="text-center mb-4">
            <img src="@/assets/icm-logo.svg" alt="ICM.com" class="mx-auto h-8" />
        </div>
        <div class="flex items-center justify-center mb-3">
          <svg
            class="h-6 w-6 text-yellow-400 mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            />
          </svg>
          <h3 class="text-lg font-semibold text-yellow-700">
             {{ $t("important-information") }}
          </h3>
        </div>
        <p class="text-sm text-gray-700 mb-4">
            {{ $t("to-comply-with-regulatory-requirements-you-are-required-to-provide") }} <strong>30-06-2026.</strong>
        </p>
        <p class="text-sm text-gray-700 mt-2 mb-4">

        </p>
        <br>
        <p><a
            :href="computedPdfUrl || null"
            target="_blank"
            rel="noopener noreferrer"
            class="text-blue-600 hover:underline { 'pointer-events-none opacity-50': !computedPdfUrl }"
        >
            {{ $t("click-here-to-download") }}
        </a></p>
        <br>
        <p class="text-sm text-gray-700 mt-2 mb-4">Once completed, you may upload the signed document using the 'Upload Documents' button within the ICM Access Portal or alternatively email the document to support@icm.com</p>

        <button
          class="block text-sm text-gray-500 mt-3 mx-auto hover:underline"
          @click="$emit('close')"
        >
          {{ $t("remind-me-later") }}
        </button>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HighRiskCorpratePopup",
    props: {
    visible: {
      type: Boolean,
      required: true
    },
    countdown: {
            type: Number,
            default: 0,
        },
        deadline: {
            type: Date,
            required: true
        },
  },
  emits: ["close"],
  data() {
    return {
      timeLeft: '',   // Will hold countdown string like "2 days 5 hours 3 minutes"
      countdownTimer: null
    };
  },
  computed: {
     ...mapGetters(["get_profile", "get_user_data","get_country_risk_map"]),
    userLanguage() {
    return this.get_profile?.profile?.language;
   },
   computedPdfUrl() {
      const lang = this.$store.getters.get_lang || 'en';  

      const mapICMMU = {
        en: '/CRS-Corporate-Entity-Self-Certification-Form.pdf',
        ar: '/CRS-Corporate-Entity-Self-Certification-Form.pdf',
      };

      const whitelabel = process.env.VUE_APP_WHITELABEL;

      if (whitelabel === 'ICMMU') {
        return mapICMMU[lang] || mapICMMU.en;
      } 

      return mapICMMU.en; // fallback

    },
    shouldShow() {
        return [
          "backoffice@skylinkscapital.com",
          "Support@icmcapital.com",
          "sjezzini@supremefxtrading.com",
          "email@sugandhgroup.com",
          "ed@cmw.ae",
          "mrgalool@gmail.com",
          "fundtron@gmail.com",
          "subhirajaaacoount@gmail.com",
          "Paliwalh02@gmail.com",
          "aljahan.co@gmail.com",
          "gbsndxb@gmail.com",
          "jobbymathewphilip@gmail.com",
          "dragos.m@artisgain.com",
          "alkhabti.skyline@gmail.com",
          "Ayman.alhashmi7@gmail.com",
          "info@darinvestments.ae",
          "mathew.jobby1@gmail.com",
          "zikudemnguni@gmail.com",
          "office@orbit-invest.ae",
          "info@billionbees.ae",
          "admin@012sfbme.com",
          "partnerships@fxrebate.eu",
          "admrxsmart@gmail.com",
          "murtazahamdani53@gmail.com",
          "saqer.abdelfattah@aswaqinvest.com",
          "Sameer@saiy.co.za",
          " affreferltd@gmail.com",
          "shreyans.patwa@sugandhcommodities.com",
          "saqer.abdelfattah@aswaqinvest.comm",
          "accounts@supremefxtrdaing.com",
          "davevivek_om@hotmail.co.uk",
          "IBfundtron@gmail.com",
          "Tradezera@gmail.com",
          "marketing@artisgain.com",
          "Ahmed.skylinev@gmail.com",
          "m2490.25bb@gmail.com",
          "Realtimestories8@gmail.com",
          "mccxinvest@gmail.com",
          "ops@billionbeesfx.com",
          "Knassour@sfbme.com",
          "a5556@fxrebate.eu",
          "info@rxsmartglobal.com",
          "Saqer.abdelfattah@gmail.comm",
          "gerald@saiy.co.za",
          "amir@affrefer.com",
          "info@sugandhcommodities.com",

          //dev
          "krisdev0415+11220@gmail.com",
          "krisdev0415+11222@gmail.com",

        ];

      },
    formattedCountdown() {
        const minutes = Math.floor(this.countdown / 60);
        const seconds = this.countdown % 60;
        return `${minutes}:${String(seconds).padStart(2, '0')}`;
    },
    
  },
  
  mounted() {
     this.startCountdown();
    },
  beforeDestroy() {
      clearInterval(this.countdownTimer);
    },
  methods: {
        startCountdown() {
            this.updateTimeLeft();
            this.countdownTimer = setInterval(this.updateTimeLeft, 1000);
        },
        updateTimeLeft() {
            const deadline = new Date("2026-12-31T00:00:00"); // 15th April 2026
            const now = new Date();
            const diff = deadline - now;

            if (diff <= 0) {
            this.timeLeft = '0 minutes';
            clearInterval(this.countdownTimer);
            //this.$emit('lockout'); // Optional: trigger lockout action
            this.$store.commit('SET_TAX_LOCKOUT', true)
            return;
            }

            const minutes = Math.floor(diff / 1000 / 60) % 60;
            const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
            const days = Math.floor(diff / 1000 / 60 / 60 / 24);

            this.timeLeft = `${days}d ${hours}h ${minutes}m`;
        }
    }
};
</script>
<style scoped>
/* Simple popup styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  width: 400px;
  text-align: center;
}
</style>
